export const WAIT_LIST = 'WAIT_LIST';
/**
 * Default value for radius used in location search
 * @type {Number}
 */
export const SEARCH_RADIUS = 100;
export const TIMEZONE_REGEX = /((\\+|-)[0-9]{2}:[0-9]{2})?$/;
export const SEPARATOR = '|';
export const SOLD_OUT_SESSIONS = 'Sold out sessions';
